import { BusinessModelRef, ConfigurationRef, InjectionModelRef } from '../ScenarioReference';
import assignToThis from '../../helper/assignToThis';
import { ScenarioRenFrPV } from './pv/ScenarioRenFrPV';
import { ScenarioRenFrWind } from './wind/ScenarioRenFrWind';
import { ScenarioSizing } from '../sizing/ScenarioSizing';
import { ProjectMeta } from '@/classes/ProjectMeta';
import { ScenarioGenerator } from '../generator/ScenarioGenerator';
import { ScenarioBattery } from '../battery/ScenarioBattery';
import { ScenarioGrid } from '../grid/ScenarioGrid';
import { ScenarioRevenue } from './revenue/ScenarioRevenue';
import { ScenarioCapex } from './capex/ScenarioCapex';
import { ScenarioOpex } from './opex/ScenarioOpex';
import { ScenarioStructureFinance } from './structure-finance/ScenarioStructureFinance';

const HAS_GRID = 1;
const HAS_GRID24 = 2;
const HAS_INJECTION = 4;

const CONFIGURATION_BY_KEY: any = {};
CONFIGURATION_BY_KEY['c' + 0] = ConfigurationRef.configuration_off_grid_self_consumption;

CONFIGURATION_BY_KEY['c' + (HAS_GRID)] = ConfigurationRef.configuration_bad_grid_self_consumption_grid;

CONFIGURATION_BY_KEY['c' + (HAS_GRID + HAS_GRID24)] = ConfigurationRef.configuration_self_consumption_without_injection_grid_24;

CONFIGURATION_BY_KEY['c' + (HAS_GRID + HAS_GRID24 + HAS_INJECTION) + InjectionModelRef.total_injection] = ConfigurationRef.configuration_total_injection_grid_24_injection;


export class ScenarioRenFr {

  public static getConfiguration(scenario: ScenarioRenFr): string | null {
    // we need at least a response to the first step of the wizard to determine a configuration
    if (scenario.hasGrid == null) {
      return null;
    }

    const hasGrid = scenario.hasGrid;
    const hasGrid24 = hasGrid && scenario.grid && scenario.grid.hasGrid24;;
    const hasInjection = hasGrid24 && scenario.hasInjection;

    let mask = 0;
    mask += hasGrid ? HAS_GRID : 0;
    mask += hasGrid24 ? HAS_GRID24 : 0;
    mask += hasInjection ? HAS_INJECTION : 0;
    const key = 'c' + mask + (scenario.hasInjection && scenario.injectionModelRef ? scenario.injectionModelRef : '');
    return CONFIGURATION_BY_KEY[key];
  }

  public project: ProjectMeta | null = null;
  public uuid?: string | null = null;
  public isRenFrance: boolean = true;

  public name: string | null = null;
  public referenceScenario: string | null = null;
  public analyticalCode: string | null = null;
  public spv: string | null = null;
  public projectManager: string | null = null;
  public startDate: string | null = '';
  public constructionDuration: number | null = null;
  public exploitationDuration: number | null = null;
  public energy: string | null = null;
  public technology: string | null = null;
  public region: string | null = null;
  public metropoleRegion: string | null = null;

  public hasGrid: boolean | null = null;
  public hasGenset: boolean | null = null;
  public hasBattery: boolean | null = null;
  public hasInjection: boolean | null = null;
  public grid: ScenarioGrid | null = null;
  public generator: ScenarioGenerator | null = null;
  public battery: ScenarioBattery | null = null;

  public businessModelRef: BusinessModelRef | null = null;
  public injectionModelRef: InjectionModelRef | null = null;

  public ren_fr_pv: ScenarioRenFrPV | null = null;
  public ren_fr_wind: ScenarioRenFrWind | null = null;
  public revenue: ScenarioRevenue | null = null;
  public capex: ScenarioCapex | null = null;
  public opex: ScenarioOpex | null = null;
  public structure_finance: ScenarioStructureFinance | null = null;
  

  public sizing: ScenarioSizing | null = null;

   public constructor(obj: Partial<ScenarioRenFr> = {}) {
    assignToThis(this, obj);

    this.businessModelRef = this.businessModelRef ? BusinessModelRef[this.businessModelRef] : null;
    this.injectionModelRef = this.injectionModelRef ? InjectionModelRef[this.injectionModelRef] : null;
    this.grid = this.grid ? new ScenarioGrid(this.grid) : null;
 
    this.ren_fr_pv = this.ren_fr_pv ? new ScenarioRenFrPV(this.ren_fr_pv) : null;
    this.ren_fr_wind = this.ren_fr_wind ? new ScenarioRenFrWind(this.ren_fr_wind) : null;
    this.revenue = this.revenue ? new ScenarioRevenue(this.revenue) : null;
    this.capex = this.capex ? new ScenarioCapex(this.capex) : null;
    this.opex = this.opex ? new ScenarioOpex(this.opex) : null;
    this.structure_finance = this.structure_finance ? new ScenarioStructureFinance(this.structure_finance) : null;
  }

}
